module.exports = __webpack_public_path__ + "img/Deaminasevariants_D.ffe41889.svg";